
export const featurePaths = {
    Index: "/Index"
} as const;

export const apiPaths = {} as const;
